import axios from 'axios'
import Embedo from 'embedo'
import _ from 'lodash'
import './sentry'
import './helpers/sentry-helper'


window._ = _

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'


const embedo = new Embedo()
Array.from(document.getElementsByTagName('oembed')).forEach((element) => {
    let d = document.createElement('div')
    element.parentNode.appendChild(d)
    embedo.load(d, element.getAttribute('url'))
})
